'use client';

import type { AuthSessionInfo } from '@/app/api/auth/_lib/types';
import EmbeddedAuth from './embedded-auth';
import type { AuthInteractionMode } from './interactions/types';

export default function ModernAuthModal({
  initialMode = 'login',
  onAuthenticated,
  onSuccess,
  onClose,
}: {
  initialMode?: AuthInteractionMode;
  onAuthenticated?: (session: AuthSessionInfo) => void;
  onSuccess?: (session: AuthSessionInfo) => void;
  onClose?: () => void;
}) {
  return (
    <EmbeddedAuth
      initialMode={initialMode}
      onAuthenticated={(session) => {
        onAuthenticated?.(session);
        onSuccess?.(session);
        onClose?.();
      }}
    />
  );
}
